import { KeyTermUnit } from '@client/graphql/__generated__/types';

export const roundRangeLabels = (num: number, unit: KeyTermUnit): number => {
  if (num === 0) return 0;

  const magnitude = Math.floor(Math.log10(Math.abs(num)));
  const roundingFactor =
    // Binds the range labels to the nearest 5 or 10
    (unit === KeyTermUnit.DAYS ? 10 : 5) * Math.pow(10, magnitude - 2);

  return Math.round(num / roundingFactor) * roundingFactor;
};

export const calculateRoundedRangeLabels = (
  num: number,
  unit: KeyTermUnit
): number => {
  if (num === 0) return 0;

  const magnitude = Math.floor(Math.log10(Math.abs(num)));
  const roundingFactor =
    // Binds the range labels to the nearest 5 or 10
    (unit === KeyTermUnit.DAYS ? 10 : 5) * Math.pow(10, magnitude - 2);

  return Math.round(num / roundingFactor) * roundingFactor;
};

export const calculateRangeValues = (
  fullRange: [number, number],
  unit: KeyTermUnit
) => {
  const difference = calculateRoundedRangeLabels(
    (fullRange[1] - fullRange[0]) / 3,
    unit
  );
  const minRangeValue =
    fullRange[0] - difference > 0 ? fullRange[0] - difference : 0;
  const maxRangeValue = fullRange[1] + difference;

  return {
    difference,
    maxRangeValue,
    minRangeValue,
  };
};

// For better type inference
export function calculateDotPosition(
  value: number,
  minRangeValue: number,
  maxRangeValue: number,
  shouldReturnNumberValue: true
): number;
export function calculateDotPosition(
  value: number,
  minRangeValue: number,
  maxRangeValue: number,
  shouldReturnNumberValue: false
): string;
export function calculateDotPosition(
  value: number,
  minRangeValue: number,
  maxRangeValue: number,
  shouldReturnNumberValue: boolean
): number | string {
  // Calculate percentage (0-100)
  const position =
    ((value - minRangeValue) / (maxRangeValue - minRangeValue)) * 100;

  // Clamp the value between 0-100 to ensure dot stays within bounds
  const clampedPosition = Math.max(0, Math.min(100, position));

  if (shouldReturnNumberValue) {
    return clampedPosition;
  }

  // Account for padding on range slider
  const addOrSubtract = `${(clampedPosition / 100) * -8 + 4}px`;
  const leftValue = `calc(${clampedPosition}% + ${addOrSubtract})`;

  return leftValue;
}
